<hero-block>
  <div class="img-container { props.hero2imgurlmobile ? 'bottom-image' : null }" style="background-image: url({ props.imgurl ? props.imgurl : props.hero2imgurl })"></div>
  <div class="img-container-tablet { props.hero2imgurltablet ? 'bottom-image' : null }" style="background-image: url({ props.imgurltablet ? props.imgurltablet : props.hero2imgurltablet })"></div>
  <div class="img-container-mobile { props.hero2imgurlmobile ? 'bottom-image' : null }" style="background-image: url({ props.imgurlmobile ? props.imgurlmobile : props.hero2imgurlmobile })"></div>
  <div class="background-elements" if={ !props.hero2imgurl }>
    <div class="rect solid rect1"></div>
    <div class="rect solid rect2"></div>
    <div class="rect green-stripes rect3"></div>
    <div class="rect yellow-stripes rect4"></div>
    <div class="rect solid rect5"></div>
    <div class="rect green-stripes rect6"></div>
  </div>
  <div class="background-elements { props.hero2heading1 ? 'bottom-section' : null }" if={ props.hero2imgurl }>
    <div class="rect solid bottom-rect1"></div>
    <div class="rect solid bottom-rect2"></div>
    <div class="rect green-stripes bottom-rect3"></div>
    <div class="rect yellow-stripes bottom-rect4"></div>
    <div class="rect solid bottom-rect5"></div>
  </div>
  <div class="text-container { props.hero2heading1 ? 'bottom-section' : null }">

    <h1 class="h1 h1-small { props.hero2heading1 ? 'bottom-section' : null }">{ props.heading1 ? props.heading1 : props.hero2heading1 }</h1>
    <h1 if={ props.heading2 } class="h1">{ props.heading2 }</h1>
    <p class="p { props.hero2heading3 ? 'bottom-section-text' : null }">{ props.heading3 ? props.heading3 : props.hero2heading3 }</p>
    <jd-button if={ props.ctaurl } variant="transparenty" size="small" same-window="true" href="{ props.ctaurl }">
      { props.cta }
    </jd-button>

  </div>
  
  <script type="ts">
    import {RiotComponentExport} from 'riot';
    import JdButton from '../../ui-component/buttons/jd-button.riot';

    interface Props {
      imgurl: string;
      hero2imgurl: string;
      imgurlmobile: string;
      hero2imgurlmobile: string;
      imgurltablet: string;
      hero2imgurltablet: string;
      heading1: string;
      hero2heading1: string;
      heading2: string;
      heading3: string;
      hero2heading3: string;
      ctaurl: string;
      cta: string;
    }
    
    function build(): RiotComponentExport<Props, never> {
      return {};
    }
    
    build.components = {
      JdButton
    };
    
    export default build;
  </script>
  
  <style type="scss">
    @use './src/client/sass/abstracts/colors';
    @use './src/client/sass/abstracts/fonts';
    @use './src/client/sass/abstracts/respond';

    $slideSpacing: 0.5rem;

    :host {
      position: relative;
      text-align: center;
      display: block;
      overflow: hidden;

    }

    .text-container {
      padding: 0 20px;
      position: relative;
      z-index: 1;
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 723px;
      justify-content: center;
      &.bottom-section {
        min-height: 619px;
      }
      .bottom-section,
      .bottom-section-text {
        max-width: 415px;
        @include respond.smallscreen-up {
          max-width: 440px;
        }
      }
      @include respond.smallscreen-up {
        min-height: 853px;
        &.bottom-section {
          min-height: 853px;
        }
      }
      @include respond.mediumscreen-up {
        min-height: 853px;
        &.bottom-section {
          min-height: 904px;
        }
      }
    }

    .h1 {
      font-size: 2.625rem;
      line-height: 1.2;
      text-transform: uppercase;
      margin: 0;
      letter-spacing: 0.05rem;
      text-align: center;
      @include respond.smallscreen-up {
        font-size: 4.75rem;
        line-height: 1.2;
      }
      @include respond.mediumscreen-up {
        font-size: 5.65rem;
      }

      &-small {
        font-family: 'jd_sans_probold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size: 1.125rem;
        line-height: 1.5;
        margin: 0;
        letter-spacing: 0.2rem;
        &.bottom-section {
          letter-spacing: 0.04rem;
          font-size: 2.25rem;
          line-height: 2.3rem;
        }
        @include respond.smallscreen-up {
          font-size: 2.5rem;
          line-height: 2.6rem;
          letter-spacing: 0.04rem;
          &.bottom-section {
            font-size: 3rem;
            line-height: 3.1rem;
            letter-spacing: 0.04rem;
          }
        }
        @include respond.mediumscreen-up {
          font-size: 3rem;
          line-height: 3.1rem;
          letter-spacing: 0.04rem;
          &.bottom-section {
            font-size: 3rem;
            line-height: 3.1rem;
            letter-spacing: 0.04rem;
          }
        }
      }
    }

    .p {
      font-family: 'jd_sans_promedium', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      z-index: 1;
      position: relative;
      max-width: 417px;
      font-size: 1.125rem;
      margin-bottom: 2rem;
      text-align: center;
      @include respond.smallscreen-up {
        margin-bottom: 52px;
        max-width: 590px;
        &.bottom-section-text {
          margin-bottom: 2rem;
        }
      }
      @include respond.mediumscreen-up {
        max-width: 817px;
        &.bottom-section-text {
          margin-bottom: 2rem;
        }
      }
      @include respond.bigscreen-up {
        padding-top: 0;
        margin-bottom: 7rem;
        &.bottom-section-text {
          margin-bottom: 2rem;
        }
      }
    }

    jd-button {
      min-width: 235px;
      text-transform: uppercase;


      &[size=small] a {
        padding: 0 1.143em;
      }
    }



    .scroll-button {
      display: block;
      z-index: 2;
      position: relative;
      top: 10px;

      &:hover {
        transform: translateY(5px);
        transition: transform ease 0.2s;
      }

      @include respond.bigscreen-up {
        top: 40px;
      }
    }

    .img-container {
      display: none;

      @include respond.mediumscreen-up {
        z-index: 0;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 853px;
      }

      &:before {
        content: '';
        display: block;
        height: 100%;
        width: 100%;
        position: absolute;
      }
      &.bottom-image {
        height: 904px;
      }
    }

    .img-container-tablet {
      display: none;
      
      @include respond.smallscreen-up {
        z-index: 0;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 853px;
      }
  
      @include respond.mediumscreen-up {
        display: none;
      }
  
      &.bottom-image {
        height: 853px;
      }
    }

    .img-container-mobile {
      z-index: 0;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      width: 100%;
      height: 723px;
  
      @include respond.smallscreen-up {
        display: none;
      }
      
      &.bottom-image {
        height: 619px;
      }
    }

    .background-elements {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      &.bottom-section {
        height: 619px;
        @include respond.smallscreen-up {
          height: 853px;
        }
        @include respond.mediumscreen-up {
          height: 904px;
        }
      }

      & .rect {
        position: absolute;
      }

      & .green-stripes {
        background: repeating-linear-gradient(135deg, #0D4917, #0D4917 2px, transparent 2px, transparent 6px, #0D4917 6px);
      }
  
      & .yellow-stripes {
        background: repeating-linear-gradient(135deg, #FFDE00, #FFDE00 2px, transparent 2px, transparent 6px, #FFDE00 6px);
      }

      & .solid {
        background-color: #0D4917;
      }
      & .rect1 {
        top: 50px;
        left: 0;
        height: 16px;
        width: 65px;
        background-color: #FFDE00;
  
        @include respond.smallscreen-up {
          top: 50px;
          left: 0;
          height: 16px;
          width: 105px;
        }

        @include respond.mediumscreen-up {
          top: 145px;
          height: 18px;
          width: 285px;
        }
      }
  
      & .bottom-rect1 {
        top: 84px;
        left: 0;
        height: 13px;
        width: 144px;
        background-color: #FFDE00;
  
        @include respond.smallscreen-up {
          top: 103px;
          height: 15px;
          width: 200px;
        }
    
        @include respond.mediumscreen-up {
          top: 163px;
          height: 18px;
          width: 283px;
        }
      }


      & .rect2 {
        top: 674px;
        left: 0;
        height: 8px;
        width: 126px;
        background-color: #FFDE00;
  
        @include respond.smallscreen-up {
          top: 674px;
          left: 52px;
          height: 8px;
          width: 156px;
        }

        @include respond.mediumscreen-up {
          top: 641px;
          left: 152px;
          height: 9px;
          width: 216px;
        }
      }
  
      & .bottom-rect2 {
        top: 529px;
        left: 32px;
        height: 5px;
        width: 144px;
        background-color: #FFDE00;
        @include respond.smallscreen-up {
          height: 7px;
          left: 78px;
          width: 174px;
          top: 677px;
        }
        @include respond.mediumscreen-up {
          top: 622px;
          left: 150px;
          height: 9px;
          width: 217px;
        }
      }

      & .rect3 {
        top: 3px;
        right: 24px;
        height: 6px;
        width: 208px;
  
        @include respond.smallscreen-up {
          top: 25px;
          right: 117px;
          height: 10px;
          width: 255px;
        }
        
        @include respond.mediumscreen-up {
          top: 50px;
          right: 217px;
          height: 10px;
          width: 335px;
        }
      }
  
      & .bottom-rect3 {
        top: -77px;
        right: 217px;
        height: 9px;
        width: 334px;
        
        @include respond.smallscreen-up {
          top: 30px;
          right: 157px;
          width: 244px;
        }
        
        @include respond.mediumscreen-up {
          top: 77px;
          right: 217px;
          width: 334px;
        }
      }

      & .rect4 {
        top: 32px;
        right: 0;
        height: 7px;
        width: 42px;
  
        @include respond.smallscreen-up {
          right: 0;
          height: 9px;
          width: 87px;
          top: 65px;
        }

        @include respond.mediumscreen-up {
          right: 0;
          height: 10px;
          width: 137px;
          top: 95px;
        }
      }
  
      & .bottom-rect4 {
        top: 64px;
        right: 0;
        height: 8px;
        width: 59px;
  
        @include respond.smallscreen-up {
          right: 0;
          height: 9px;
          width: 98px;
          top: 83px;
        }
    
        @include respond.mediumscreen-up {
          right: 0;
          height: 10px;
          width: 138px;
          top: 123px;
        }
      }

      & .rect5 {
        top: 73px;
        right: 0;
        height: 19px;
        width: 67px;
  
        @include respond.smallscreen-up {
          height: 25px;
          width: 126px;
          top: 111px;
        }
        
        @include respond.mediumscreen-up {
          height: 31px;
          width: 176px;
          top: 161px;
        }
      }
  
      & .bottom-rect5 {
        top: 108px;
        right: 0;
        height: 19px;
        width: 84px;
  
        @include respond.smallscreen-up {
          height: 24px;
          width: 128px;
          top: 149px;
        }
        
        @include respond.mediumscreen-up {
          height: 32px;
          width: 178px;
          top: 189px;
        }
      }

      & .rect6 {
        top: 507px;
        left: -210px;
        height: 28px;
        width: 75px;
        
        @include respond.mediumscreen-up {
          left: 0;
        }
      }

      & .rect7 {
        top: 288px;
        right: 0;
        height: 5px;
        width: 8px;
        @include respond.mediumscreen-up {
          top: 380px;
          right: -40px;
          height: 8px;
          width: 130px;
        }
        @include respond.bigscreen-up {
          right: 100px;
        }
      }

    }

  </style>

</hero-block>